var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab_bar_item",on:{"click":_vm.clickItem}},[_c('div',{class:_vm.isActiveColor},[_vm._t("text")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }